import { render } from "./icon.vue?vue&type=template&id=c007fb8c"
import script from "./icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./icon.vue?vue&type=script&setup=true&lang=ts"

import "./icon.vue?vue&type=style&index=0&id=c007fb8c&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "c007fb8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c007fb8c', script)) {
    api.reload('c007fb8c', script)
  }
  
  module.hot.accept("./icon.vue?vue&type=template&id=c007fb8c", () => {
    api.rerender('c007fb8c', render)
  })

}

script.__file = "resources/scripts/components/ui/icon.vue"

export default script